import React, { useState, useEffect } from 'react';
import { FaBox, FaTrash, FaEdit, FaCar, FaChevronRight } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';
import { getMyPackages, deletePackage, updatePackage } from '../services/packages.service';
import { getMyTravels, completarViaje } from '../services/travels.service';
import BottomNav from '../components/BottomNav';
import PackageDetail from './PackageDetail';
import Navbar from '../components/Navbar';

const STATUS_ORDER = ['pendiente', 'aceptado', 'recogido', 'entregado', 'confirmado'];
const STATUS_CONFIG = {
  pendiente:  { label: 'Pendiente',  color: '#f59e0b', bg: '#f59e0b15' },
  aceptado:   { label: 'Aceptado',   color: '#3b82f6', bg: '#3b82f615' },
  recogido:   { label: 'Recogido',   color: '#6366f1', bg: '#6366f115' },
  entregado:  { label: 'Entregado',  color: '#22c55e', bg: '#22c55e15' },
  confirmado: { label: 'Confirmado', color: '#6b7280', bg: '#6b728015' },
  activo:     { label: 'Activo',     color: '#22c55e', bg: '#22c55e15' },
  completado: { label: 'Completado', color: '#6b7280', bg: '#6b728015' },
};

export default function MyPackages({ onBack, onTabChange, openPackageId, onClearPackage, openChatDirecto, onOpenPackage }) {
const { token, user } = useAuth();
  const [tab, setTab] = useState('paquetes');
  const [packages, setPackages] = useState([]);
  const [travels, setTravels] = useState([]);
  const [message, setMessage] = useState('');
  const [editing, setEditing] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [completandoViaje, setCompletandoViaje] = useState(null);

  useEffect(() => {
    getMyPackages(token).then(setPackages).catch(() => setMessage('Error cargando envíos'));
    getMyTravels(token).then(setTravels).catch(() => setMessage('Error cargando viajes'));
  }, [token]);

  useEffect(() => {
    if (openPackageId && packages.length > 0) {
      setSelectedId(openPackageId);
      if (onClearPackage) onClearPackage();
    }
  }, [openPackageId, packages]);

  if (selectedId) return <PackageDetail packageId={selectedId} onBack={() => setSelectedId(null)} openChatDirecto={openChatDirecto} onOpenPackage={onOpenPackage} />;

  const handleDelete = async () => {
    try {
      await deletePackage(confirmDelete, token);
      setPackages(packages.filter(p => p.id !== confirmDelete));
      setConfirmDelete(null);
    } catch { setMessage('Error borrando envío'); }
  };

  const handleUpdate = async (pkg) => {
    try {
      const updated = await updatePackage(pkg.id, pkg, token);
      setPackages(packages.map(p => p.id === updated.id ? updated : p));
      setEditing(null);
    } catch { setMessage('Error actualizando envío'); }
  };

  const handleCompletarViaje = async (travelId) => {
    setCompletandoViaje(travelId);
    try {
      const updated = await completarViaje(travelId, token);
      setTravels(travels.map(t => t.id === updated.id ? updated : t));
    } catch {
      setMessage('Error al completar el viaje');
    }
    setCompletandoViaje(null);
  };

  const grouped = STATUS_ORDER.reduce((acc, status) => {
    const items = packages.filter(p => p.status === status);
    if (items.length > 0) acc[status] = items;
    return acc;
  }, {});

  return (
    <div className="min-h-screen pb-24" style={{backgroundColor: '#111318'}}>
      <Navbar onOpenPackage={onOpenPackage} />

      <div className="max-w-lg mx-auto px-4 pt-6">
        {message && (
          <div className="text-red-400 text-sm mb-4 px-4 py-2 rounded-xl"
            style={{backgroundColor: '#ff000015', border: '1px solid #ff000030'}}>
            {message}
          </div>
        )}

        {/* Tabs */}
        <div className="flex gap-2 mb-6 p-1 rounded-2xl" style={{backgroundColor: '#1a1d24'}}>
          {[
            { id: 'paquetes', icon: <FaBox />, label: 'Mis envíos', count: packages.length },
            { id: 'viajes', icon: <FaCar />, label: 'Mis viajes', count: travels.length },
          ].map(t => (
            <button key={t.id} onClick={() => setTab(t.id)}
              style={tab === t.id ? {backgroundColor: '#f97316', flex: 1} : {flex: 1, backgroundColor: 'transparent'}}
              className="flex items-center justify-center gap-2 py-2.5 rounded-xl transition duration-200">
              <span style={{color: tab === t.id ? 'white' : '#6b7280', fontSize: '13px'}}>{t.icon}</span>
              <span style={{color: tab === t.id ? 'white' : '#6b7280', fontSize: '13px', fontWeight: tab === t.id ? '600' : '400'}}>
                {t.label}
              </span>
              <span style={{
                backgroundColor: tab === t.id ? '#ffffff25' : '#ffffff10',
                color: tab === t.id ? 'white' : '#6b7280',
                fontSize: '10px', fontWeight: '600',
                padding: '1px 6px', borderRadius: '20px'
              }}>{t.count}</span>
            </button>
          ))}
        </div>

        {/* Paquetes agrupados */}
        {tab === 'paquetes' && (
          packages.length === 0 ? (
            <div className="text-center py-16">
              <div className="text-5xl mb-4 opacity-20">📦</div>
              <p className="text-gray-500 text-sm">No tienes envíos todavía</p>
            </div>
          ) : (
            STATUS_ORDER.filter(s => grouped[s]).map(status => {
              const st = STATUS_CONFIG[status];
              const items = grouped[status];
              return (
                <div key={status} className="mb-5">
                  {/* Cabecera grupo */}
                  <div className="flex items-center gap-2 mb-2 px-1">
                    <span style={{color: st.color, backgroundColor: st.bg, fontSize: '10px', fontWeight: '700', padding: '3px 10px', borderRadius: '20px'}}>
                      {st.label}
                    </span>
                    <span style={{color: '#3a3d45', fontSize: '11px'}}>{items.length} envío{items.length > 1 ? 's' : ''}</span>
                    <div className="flex-1 h-px" style={{backgroundColor: '#1e2028'}}></div>
                  </div>

                  {/* Tarjetas */}
                  {items.map(pkg => (
                    <div key={pkg.id} onClick={() => setSelectedId(pkg.id)}
                      style={{backgroundColor: '#1a1d24', border: '1px solid #2a2d35'}}
                      className="rounded-2xl p-4 mb-2 cursor-pointer transition duration-200 hover:border-orange-500">
                      {editing?.id === pkg.id ? (
  <div className="flex flex-col gap-3" onClick={e => e.stopPropagation()}>
    {[
      { field: 'from', placeholder: '¿Desde dónde?' },
      { field: 'to', placeholder: '¿Hasta dónde?' },
      { field: 'description', placeholder: 'Qué necesitas enviar' },
      { field: 'price', placeholder: 'Contribución al viaje (€)' },
    ].map(({ field, placeholder }) => (
      <input key={field} value={editing[field] || ''}
        onChange={e => setEditing({...editing, [field]: e.target.value})}
        placeholder={placeholder}
        style={{backgroundColor: '#111318', border: '1px solid #2a2d35', color: 'white',
          borderRadius: '12px', padding: '11px 14px', fontSize: '13px', width: '100%'}}
        className="focus:outline-none focus:ring-1 focus:ring-orange-500 placeholder-gray-600" />
    ))}
    <div>
      <p style={{color: '#6b7280', fontSize: '11px', marginBottom: '6px'}}>Tu mensaje personal</p>
      <textarea
        value={editing.mensajePersonal || ''}
        onChange={e => setEditing({...editing, mensajePersonal: e.target.value})}
        rows={3}
        placeholder="Ej: Buenas! Si alguien viaja hacia Barcelona..."
        style={{backgroundColor: '#111318', border: '1px solid #2a2d35', color: 'white',
          borderRadius: '12px', padding: '11px 14px', fontSize: '13px', width: '100%',
          resize: 'none', lineHeight: '1.5'}}
        className="focus:outline-none focus:ring-1 focus:ring-orange-500 placeholder-gray-600"
      />
    </div>
    <div className="flex gap-2">
      <button onClick={() => handleUpdate(editing)}
        style={{flex: 1, backgroundColor: '#f97316', color: 'white',
          fontWeight: '600', padding: '10px', borderRadius: '12px', fontSize: '13px'}}>
        Guardar
      </button>
      <button onClick={() => setEditing(null)}
        style={{flex: 1, backgroundColor: '#2a2d35', color: '#9ca3af',
          fontWeight: '600', padding: '10px', borderRadius: '12px', fontSize: '13px'}}>
        Cancelar
      </button>
    </div>
  </div>
                      ) : (
                        <div className="flex items-center gap-3">
                          <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2 mb-1 flex-wrap">
  <p className="text-white font-semibold text-sm truncate">{pkg.from} → {pkg.to}</p>
  {pkg.receiverId === user?.id && pkg.receiverId !== pkg.senderId && (
    <span style={{backgroundColor:'#6366f115', color:'#818cf8',
      fontSize:'10px', fontWeight:'600', padding:'1px 8px', borderRadius:'20px', flexShrink:0}}>
      Recibes
    </span>
  )}
  {pkg.driverId === user?.id && (
    <span style={{backgroundColor:'#3b82f615', color:'#3b82f6',
      fontSize:'10px', fontWeight:'600', padding:'1px 8px', borderRadius:'20px', flexShrink:0}}>
      Viajero
    </span>
  )}
</div>
{pkg.description && <p className="text-gray-500 text-xs truncate mb-1.5">{pkg.description}</p>}
<span className="text-gray-600 text-xs">{pkg.weight}kg · {pkg.price}€</span>
{pkg.status === 'pendiente' && pkg.senderId === user?.id && (
  <div className="flex gap-2 mt-2.5" onClick={e => e.stopPropagation()}>
                                <button onClick={() => setEditing(pkg)}
                                  style={{backgroundColor: '#2a2d35', fontSize: '11px'}}
                                  className="flex items-center gap-1.5 text-gray-400 px-3 py-1.5 rounded-lg">
                                  <FaEdit /> Editar
                                </button>
                                <button onClick={() => setConfirmDelete(pkg.id)}
                                  style={{backgroundColor: '#ff000015', border: '1px solid #ff000030', fontSize: '11px'}}
                                  className="flex items-center gap-1.5 text-red-400 px-3 py-1.5 rounded-lg">
                                  <FaTrash /> Borrar
                                </button>
                              </div>
                            )}
                          </div>
                          <FaChevronRight style={{color: '#2a2d35', fontSize: '12px', flexShrink: 0}} />
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              );
            })
          )
        )}

        {/* Viajes */}
        {tab === 'viajes' && (
          travels.length === 0 ? (
            <div className="text-center py-16">
              <div className="text-5xl mb-4 opacity-20">🚗</div>
              <p className="text-gray-500 text-sm">No tienes viajes publicados todavía</p>
            </div>
          ) : (
            travels.map(travel => {
              const st = STATUS_CONFIG[travel.status] || STATUS_CONFIG.activo;
              return (
                <div key={travel.id}
                  style={{backgroundColor: '#1a1d24', border: '1px solid #2a2d35'}}
                  className="rounded-2xl p-4 mb-3">
                  <p className="text-white font-semibold text-sm mb-1">{travel.from} → {travel.to}</p>
                  <div className="flex items-center gap-3">
                    <span style={{color: st.color, backgroundColor: st.bg, fontSize: '10px', fontWeight: '600', padding: '2px 8px', borderRadius: '20px'}}>
                      {st.label}
                    </span>
                    <span className="text-gray-600 text-xs">🚗 {travel.vehicleType}</span>
                  </div>
                  {travel.departureDate && (
                    <p className="text-gray-600 text-xs mt-1.5">📅 {new Date(travel.departureDate).toLocaleString('es-ES')}</p>
                  )}
                  {travel.status === 'activo' && (
                    <button
                      onClick={() => handleCompletarViaje(travel.id)}
                      disabled={completandoViaje === travel.id}
                      style={{
                        marginTop: '10px', width: '100%',
                        backgroundColor: completandoViaje === travel.id ? '#2a2d35' : '#22c55e15',
                        color: completandoViaje === travel.id ? '#6b7280' : '#22c55e',
                        border: `1px solid ${completandoViaje === travel.id ? '#2a2d35' : '#22c55e30'}`,
                        fontSize: '12px', fontWeight: '600', padding: '9px', borderRadius: '10px',
                        cursor: completandoViaje === travel.id ? 'default' : 'pointer'
                      }}>
                      {completandoViaje === travel.id ? 'Completando...' : '✅ Marcar viaje como completado'}
                    </button>
                  )}
                </div>
              );
            })
          )
        )}
      </div>

      {confirmDelete && (
        <div className="fixed inset-0 flex items-center justify-center z-50 px-4" style={{backgroundColor: '#00000080'}}>
          <div style={{backgroundColor: '#1a1d24', border: '1px solid #2a2d35'}} className="rounded-2xl p-6 w-full max-w-sm">
            <h3 className="text-white font-semibold text-base mb-1">¿Borrar envío?</h3>
            <p className="text-gray-500 text-sm mb-5">Esta acción no se puede deshacer.</p>
            <div className="flex gap-2">
              <button onClick={handleDelete} style={{backgroundColor: '#ef4444'}} className="flex-1 text-white font-semibold py-2.5 rounded-xl text-sm">Borrar</button>
              <button onClick={() => setConfirmDelete(null)} style={{backgroundColor: '#2a2d35'}} className="flex-1 text-gray-300 font-semibold py-2.5 rounded-xl text-sm">Cancelar</button>
            </div>
          </div>
        </div>
      )}

      <BottomNav active="activity" onChange={onTabChange} unreadCount={0} />
    </div>
  );
}